import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {MidiCCParameter} from 'decentralized/EthereumEvents.js';
import MidiCCContract from '../contracts/MidiCCContract.js';
import {MIDI_CC} from 'decentralized/transactions/contracts.js';
import {web3} from '../web3.js';

export const newMidiCCParameter = (deviceName, ccNumber, parameterName) => {
    new EthereumTransaction(
        MIDI_CC,
        'newMidiCCParameter',
        [
            web3.utils.fromAscii(deviceName),
            ccNumber,
            web3.utils.fromAscii(parameterName)
        ]
    )
        .execute();
};

export const getMidiCCParametersForDevice = async (deviceName) => {
    let query = new BackendQuery(
        new MidiCCContract().contractAddress)
        .from(MidiCCParameter)
        .select("ccNumber")
        .select("parameterName")
        .where("deviceName", deviceName);

    return await query.executeQuery();
};
